import iconMicGray from "../../../assets/images/100-mic-gray.svg";
import noCameraUser from "../../../assets/images/user-with-disabled-camera.svg";
import { Video } from "../../video-element";

const ParticipantCamera = ({ participantData, videoStream, videoHeight }) => (
  <div className="meeting-controller-widget-user">
    {(participantData.audio_mute === "muted" || participantData.audio_mute === null) && <img src={iconMicGray} className="mic i i-12" alt="" />}
    <div
      style={{
        width: "100%",
        overflow: "hidden",
        position: "relative",
      }}>
      {videoStream && videoStream.getVideoTracks().length > 0 ? (
        <Video
          autoPlay
          srcObject={videoStream}
          style={{
            width: "100%",
            objectFit: "cover",
            position: "absolute",
            top: `-${videoHeight * (+participantData.pid - 1)}px`,
          }}
        />
      ) : (
        <img src={noCameraUser} className="no-cam-icon" width="24" height="24" alt="" />
      )}
    </div>
  </div>
);

export default ParticipantCamera;
